import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
})

axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = JSON.parse(localStorage.getItem('accessToken')) || ''

    if (accessToken) {
      config.headers['x-access-token'] = accessToken
    }

    return config
  },
  (err) => Promise.reject(err)
)

export default axiosInstance
